module.exports = __webpack_public_path__ + "static/hero-38c4be879f2430c502cef967a7027185.jpg";